export default __webpack_public_path__ + "static/coin-background-f54d4d06e12f357685bb6b09bf374ef3.png";